export async function postJson<TPayload, TResponse>(url: string, payload: TPayload): Promise<TResponse> {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  const data = (await response.json()) as TResponse;

  if (!response.ok) {
    throw new Error("API request failed");
  }

  return data;
}
